module.exports = __webpack_public_path__ + "img/security-100.b2b4a81c.gif";